module.exports = "<div>\r\n    <canvas baseChart #baseChart=\"base-chart\">\r\n    </canvas>\r\n</div>\r\n<!-- [chartType]=\"this.dynamicFlow_Column.Chart_Type\"\r\n\r\n[datasets]=\"this.dynamicFlow_Column.DataColumns_DataSet\" \r\n[labels]=\"this.dynamicFlow_Column.Chart_Labels\"\r\n[legend]=\"this.dynamicFlow_Column.DataColumns_DataContainsLabel\"\r\n[options]=\"this.dynamicFlow_Column.Chart_Options\"\r\n        [colors]=\"this.dynamicFlow_Column.DataColumns_Color\"     \r\n        (chartClick)=\"onChartClick($event)\" -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/chart.component.html
// module id = ./src/app/components/common/chart.component.html
// module chunks = main